/*
 *******************************************************************************
 *
 *  Filename:   /redux/slices/common.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Common redux reducer
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Saturday, January 13, 2024 - 9:36 PM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2024/01/13  NJN Initial Build
 *
 *  Copyright (c) 2024 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: "/dashboard/default",
  error: null,
};

const updateFieldReducer = (state, action, field) => {
  if (action.payload !== null) {
    state[field] = action.payload[field];
    state.error = null;
  } else {
    state.error = `No ${field} provided.`;
  }
};

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    updatePage: (state, action) => updateFieldReducer(state, action, "page"),
  },
});

export const { updatePage } = commonSlice.actions;

export default commonSlice.reducer;
